import { setPersonalizationStudioBannerDataAction as setPersonalizationStudioBannerDataOperation } from 'editor/src/store/editor/slice';

export default setPersonalizationStudioBannerDataOperation;
